import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { Bank, RegisterUser, SelectedMode, User, Background, FilteredMode, AntecedentesMarcas, FiltratedUser, FiltratedObjetives, Objetive, FiltratedBackground, StudentFromAdmin, Antecedente, DatosBancario, EntrenamientoDia, RouteOptions, Distancias } from '../../../api/interfaces/register';
import { RegisterService } from '../../../api/services/register/register.service';
import { trainingDaysEnum, TrainingTypeEnum } from '../../../enums/training-type';
import { MobileDetectorService } from '../../../services/mobileDetector/mobile-detector.service';
import { SharedDataService } from '../../../services/sharedData/shared-data.service';
import { SnackbarService } from '../../../utils/snackbar/snackbar.service';
import { ParseTimeService } from '../../../utils/parseTime/parse-time.service';
import { AntecedentesEnum } from 'src/app/enums/antecedentes';
import { FilterDataService } from 'src/app/services/filterData/filter-data.service';
import { HoursDayFixedService } from 'src/app/utils/hoursDayFixed/hours-day-fixed.service';

@Component({
  selector: 'app-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss']
})
export class ButtonsComponent implements OnInit {

  @Input('end') end?: boolean;
  @Input('disabled') disabled?: boolean;
  @Input('bank') bank?: DatosBancario;
  @Input('mode') mode?: SelectedMode;
  @Input('user') user?: User;
  @Input('background') background?: any;
  @Input('enablePrevious') enablePrevious?: boolean;

  routeOptions: Distancias[] = [];

  isMobile: boolean = false;
  ALUMNO_ID: number;
  kmsOption: Distancias;
  metersOption: Distancias;

  constructor(
    private router: Router,
    private registerService: RegisterService,
    private snack: SnackbarService,
    private sharedData: SharedDataService,
    private mobileDetectorService: MobileDetectorService,
    private parseTime: ParseTimeService,
    private filterData: FilterDataService,
    private hoursDayFixedService: HoursDayFixedService
  ) { 
   
  }

  ngOnInit(): void {
    this.isMobile = this.mobileDetectorService.isMobile();
    this.ALUMNO_ID = parseInt(localStorage.getItem('idAlumno'),10);
    this.getOptions();
  }

  save() {
    if(this.mode) {
      sessionStorage.setItem('mode', JSON.stringify(this.mode));
      this.sharedData.changeMessage("saveStep2");
    }
    if(this.user) {
      sessionStorage.setItem('user', JSON.stringify(this.user));
      this.sharedData.changeMessage("saveStep1");
    }
    if(this.background) {
      sessionStorage.setItem('background', JSON.stringify(this.background));
      this.sharedData.changeMessage("saveStep3");
    }
  }

  onSubmit() {
    sessionStorage.setItem('bank', JSON.stringify(this.bank));
    this.sharedData.changeMessage("saveStep4");
    let aux = sessionStorage.getItem('mode') as string;

    let background = JSON.parse(sessionStorage.getItem('background'))
    let antecedente: Antecedente[] = this.filterData.filterBackground(background);
    let filteredMode: FilteredMode = this.filterData.filterDataMode(JSON.parse(sessionStorage.getItem('mode')));
    let filteredUser: FiltratedUser = this.filterData.filterUserData(JSON.parse(sessionStorage.getItem('user')), filteredMode, this.ALUMNO_ID);
    let entrenamientoDia: EntrenamientoDia[] = this.createEntrenamientoDia(JSON.parse(sessionStorage.getItem('mode')));
    
    let objetives: Objetive[] = JSON.parse(sessionStorage.getItem('objetives'));
    let objetivo: FiltratedObjetives[] = [];
    if(objetives) {
      objetivo = this.filterData.filterObjetives(objetives);
    }

    let AntecedentesMarcas: AntecedentesMarcas[] = this.filterAchievementsDynamic(JSON.parse(sessionStorage.getItem('ruta')),'ruta',background.ruta);
    let filteredPista: AntecedentesMarcas[] = this.filterAchievementsDynamic(JSON.parse(sessionStorage.getItem('pista')),'pista',background.pista);
    let filteredTrail: AntecedentesMarcas[] = this.filterAchievementsDynamic(JSON.parse(sessionStorage.getItem('trail')),'trail',background.trail);
    let filteredUltra: AntecedentesMarcas[] = this.filterAchievementsDynamic(JSON.parse(sessionStorage.getItem('ultra')),'ultra',background.ultra);

    let antecedentesMarcas: any = [];
    if(AntecedentesMarcas && AntecedentesMarcas.length > 0) {
      AntecedentesMarcas.forEach(antecedente => {
        antecedentesMarcas.push(antecedente)
      });
    };
    if(filteredTrail && filteredTrail.length > 0) {
      filteredTrail.forEach(antecedente => {
        antecedentesMarcas.push(antecedente)
      });
    };
    if(filteredPista && filteredPista.length > 0) {
      filteredPista.forEach(antecedente => {
        antecedentesMarcas.push(antecedente)
      });
    };
    if(filteredUltra && filteredUltra.length > 0) {
      filteredUltra.forEach(antecedente => {
        antecedentesMarcas.push(antecedente)
      });
    };

    if(aux) {
      this.mode = JSON.parse(aux);
    }

    let alumnosDatoBancario: DatosBancario = {
      entidad: this.bank.entidad,
      claveBancaria: this.bank.claveBancaria
    }

    let alumnosDatosBancario: DatosBancario [] = [];
    alumnosDatosBancario.push(alumnosDatoBancario);

    let email = filteredUser.email;
    let nombre = filteredUser.nombre;
    let apellido = filteredUser.apellido;
    let segundoApellido = filteredUser.segundoApellido;
    let fechaNacimiento = filteredUser.fechaNacimiento;
    let numeroDocumento = filteredUser.numeroDocumento;
    let paisId = filteredUser.paisId;
    let residencia = filteredUser.residencia;
    let prefijoCelular = filteredUser.prefijoCelular;
    let numeroCelular = filteredUser.numeroCelular;
    let prefijoEmergencia = filteredUser.prefijoEmergencia;
    let numeroEmergencia = filteredUser.numeroEmergencia;
    let peso = filteredUser.peso;
    let altura = filteredUser.altura;
    let entrenamientoTipoId = filteredUser.entrenamientoTipoId;
    //fixme: cambio de nombres
    const grupo = JSON.parse(sessionStorage.getItem('mode'));
    let grupoId: number = -1;
    if(grupo.trainingDays) {
      grupoId = grupo.trainingDays.entrenamientoGrupoId;
    } else {
      grupoId = grupo.mode;
    }
    let entrenamientoGrupoId = grupoId;
    let entrenamientoNivelId = filteredUser.entrenamientoNivelId;
    let entrenadorId = filteredUser.entrenadorId;
    let activo = filteredUser.activo;
    let ultimaModificacion = filteredUser.ultimaModificacion;
    let ultimaModificacionPor = filteredUser.ultimaModificacionPor;
    let estado = filteredUser.estado;
    let documentoTipoId = filteredUser.documentTipoId;
    let avatarUrl = filteredUser.avatarUrl;

      let data = {
        objetivo,
        antecedentesMarcas,
        antecedente,
        email,
        nombre,
        apellido,
        segundoApellido,
        fechaNacimiento,
        numeroDocumento,
        paisId,
        residencia,
        prefijoCelular,
        numeroCelular,
        prefijoEmergencia,
        numeroEmergencia,
        peso,
        altura,
        entrenamientoTipoId,
        entrenamientoGrupoId,
        entrenamientoNivelId,
        entrenadorId,
        activo,
        ultimaModificacion,
        ultimaModificacionPor,
        estado,
        documentoTipoId,
        avatarUrl,
        alumnosDatosBancario,
        entrenamientoDia
      };

    this.registerService.registerUser(data, this.ALUMNO_ID)
      .subscribe(response => {
          this.router.navigate(['/thanks']);
        },
        error => {
          console.error(error);
          this.snack.snackTranslate('snacks.error.generic');
        });
  }

  createEntrenamientoDia(mode: any) : EntrenamientoDia[] {
    let entrenamientoDias: EntrenamientoDia[] = [];
    if(mode.days) {
      mode.days.forEach(day => {
        let aux: EntrenamientoDia = {
          entrenamientoDiaTipo: trainingDaysEnum.ADITIONAL,
          diaSemana: day.index
        };
        entrenamientoDias.push(aux);
      });
    }
    if(mode.trainingDays) {
      mode.trainingDays.entrenamientoGruposDias.forEach(day => {
        let aux: EntrenamientoDia = {
          entrenamientoDiaTipo: trainingDaysEnum.IN_GROUP,
          diaSemana: day.diaSemana
        };
        entrenamientoDias.push(aux);
      });
    }
    return entrenamientoDias;
  }

  getOptions() {
    this.registerService.getRouteOptions()
    .subscribe(response => {
      this.routeOptions = response;
      let km: number = response.findIndex(option => option.distanciaDescripcion == "Kilómetros");
      let meters = this.routeOptions.findIndex(option => option.distanciaDescripcion == "Metros");
      this.routeOptions.forEach(option => {
        option.selected = false;
      });
      this.kmsOption = this.routeOptions[km];
      this.metersOption = this.routeOptions[meters];
    },
      error => {
        console.error(error);
      });
  }

  filterAchievementsDynamic(input: any, mode: string, valid: boolean) {
    let arrayAux = Array();
    if(input && valid) {
      if(mode === "pista" || mode === "ultra" || mode === "trail") {
        input.forEach(element => {
          let id: number;
          let optionId: number;
            switch (mode) {
              case "pista":
                id = AntecedentesEnum.PISTA;
                // optionId = this.metersOption.id;
                break;
              case "ultra":
                id = AntecedentesEnum.ULTRA;
                // optionId = this.kmsOption.id;
                break;
              case "trail":
                id = AntecedentesEnum.TRAIL;
                // optionId = this.kmsOption.id;
                break;
            }
            let time: number [] = this.parseTime.parseTime(element.time);
             // bugfix date
            let fechaCorregida: string = this.hoursDayFixedService.getDateWithConverted(element.date);

            let aux: AntecedentesMarcas = {
              tiempoMarcaHoras: time[0],
              tiempoMarcaMinutos: time[1],
              tiempoMarcaSegundos: time[2],
              distanciaMarca: element.distance,
              fechaMarca: fechaCorregida,
              antecedentePreguntaDetalleId: id,
              // distanciaTipoId: optionId, 
              id: null,
            };
            arrayAux.push(aux);
          });
      } else {
          input.forEach(element => {
            let time: number [] = this.parseTime.parseTime(element.time);
            
              // bugfix date
              let fechaCorregida: string = this.hoursDayFixedService.getDateWithConverted(element.date);
              let aux: AntecedentesMarcas = {
              distanciaTipoId: element.routeType.id,
              tiempoMarcaHoras: time[0],
              tiempoMarcaMinutos: time[1],
              tiempoMarcaSegundos: time[2],
              fechaMarca: fechaCorregida,
              antecedentePreguntaDetalleId: AntecedentesEnum.RUTA,
              id: null
            }
            arrayAux.push(aux);
          });
      } 
      return arrayAux;

    } else {
      return null;
    }
  }


  }

